import SuccessMessage from '@/components/pages/forms/contact/success-message';
import StepContainer from './step-container';
import { useRouter } from 'next/navigation';

export default function HeresWhatsNext() {
  const router = useRouter();

  const onContinue = () => {
    router.push('/');
  };

  return (
    <StepContainer onSubmit={onContinue} buttonDisabled={false} hideButtonIcon buttonLabel="Close">
      <SuccessMessage variant="dark" />
    </StepContainer>
  );
}
